var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "18/info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M7.99526 1.4292C4.36568 1.4292 1.41992 4.37495 1.41992 8.00454C1.41992 11.6341 4.36568 14.5799 7.99526 14.5799C11.6249 14.5799 14.5706 11.6341 14.5706 8.00454C14.5706 4.37495 11.6336 1.4292 7.99526 1.4292ZM8.6528 11.2922H7.33773V7.34701H8.6528V11.2922ZM8.6528 6.03194H7.33773V4.71687H8.6528V6.03194Z",
    fill: "#808080"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.47c7500dcbd44360cc15bb8238d79a4b.svg";
export { ForwardRef as ReactComponent };